var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.145,
    height: 50,
    viewBox: "0 0 79.145 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "developmentIcon",
    transform: "translate(-124.129 -120.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55091",
    "data-name": "Path 55091",
    d: "M202.7,144.277l-19.5-19.494a1.962,1.962,0,1,0-2.774,2.774l18.109,18.109-18.109,18.109a1.962,1.962,0,1,0,2.774,2.774l19.5-19.494a1.962,1.962,0,0,0,0-2.774Zm-55.724-19.494a1.961,1.961,0,0,0-2.774,0l-19.5,19.494a1.96,1.96,0,0,0,0,2.774l19.5,19.494a1.962,1.962,0,1,0,2.774-2.774l-18.109-18.109,18.109-18.109a1.962,1.962,0,0,0,0-2.774Zm24.415-3.173a1.962,1.962,0,1,0-3.567,1.634l-12.155,46.077a1.962,1.962,0,0,0,3.567-1.634Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentIcon);
export default __webpack_public_path__ + "static/media/developmentIcon.f9beeca79e9139b4654c7769da608197.svg";
export { ForwardRef as ReactComponent };